import { useBreakpointValue as o } from "@chakra-ui/react";
const s = (e) => o(e, { ssr: !1 });
export {
  s as useNoSSRBreakpointValue
};
//# sourceMappingURL=useNoSSRBreakpointValue.es.js.map
